import axios from "axios";
import { Message } from "element-ui";
import { getAccessToken } from "@/utils/cookie";
import store from "../store/store";

// axios 初始化
const service = axios.create({
  baseURL: process.env.VUE_APP_API_HOST,
  withCredentials: false,
  // headers: {
  //   'Content-Type': 'application/x-www-form-urlencoded'
  // },
  timeout: 180000
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    let index = config.url.indexOf("https://console-mock.apipost.cn");
    if (index > -1) {
      config.headers["Access-Token"] = "";
      config.withCredentials = false;
    } else {
      // 每次请求前，向 http 头中插入 Access-Token
      if (getAccessToken()) {
        config.headers["Access-Token"] = getAccessToken();
      }
    }
    return config;
  },
  error => {
    console.log(error + "请求拦截失败");
    Promise.reject(error);
  }
);

// 应答拦截器
service.interceptors.response.use(
  response =>
    // response.data,
    {
      if (response.data.errno === 40001) {
        store.dispatch("fedLogOut").then(() => {
          Message({
            message: response.data.message || "获取用户信息失败，请重新登录！",
            type: "error",
            duration: 3 * 1000
          });
          location.reload();
        });
      }
      return Promise.resolve(response.data);
    },
  error => {
    console.log(error);
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;
